import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy, Routes } from '@angular/router';

import { AppComponent } from './app.component';

export const ROUTES: Routes = [
    {
        path: '',
        component: AppComponent,
        children: [
            {
                path: 'o/:orgId',
                loadChildren: () => import('./org/org.routes').then(mod => mod.ROUTES),
                data: { internal: false }
            },
            {
                path: '',
                loadChildren: () => import('./org/org.routes').then(mod => mod.ROUTES),
                data: { internal: true }
            },
        ]
    },
    {
        path: '**',
        redirectTo: '/start'
    }
];

@Injectable()
export class CustomRouteReuseStrategy extends RouteReuseStrategy {
    public shouldDetach(_route: ActivatedRouteSnapshot): boolean { return false; }
    public store(_route: ActivatedRouteSnapshot, _detachedTree: DetachedRouteHandle): void {}
    public shouldAttach(_route: ActivatedRouteSnapshot): boolean { return false; }
    public retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null { return null; }
    public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return (future.routeConfig === curr.routeConfig) || (curr.data?.reuse && curr.data.reuse == future.data?.reuse);
    }
}
